<template>
<div class="survey">
    <!-- Navigation -->
    <div v-if="fimChap">
        <div class="container-fluid congratulations content-desktop">
            <div class="container container-content border-left-light pt-2 pb-5">
                <div class="row">
                    <div class="col-lg-6 px-5">
                        <!-- <img :src="getImage" class="img-fluid w-25 img-center pt-5" />-->
                        <h2 class="text-secondary extra-bold pt-3">{{ endName }}</h2>
                        <p class="light">{{ endTitle }}</p>
                    </div>
                    <div class="col-lg-6 py-3 px-5">
                        <div class="row">
                            <div class="col-12">
                                <!-- <div class="progress">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      style="width:100%;"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <p class="percent mb-4">100% Completo</p> -->
                                <p class="bold mt-3">{{ endMsg }}</p>
                            </div>
                            <div class="col-12 col-md-6 offset-md-3">
                                <!-- <button type="submit" class="btn btn-primary mt-5 mb-1">Quero ir para as finais</button> -->
                                <button type="button" class="btn btn-primary btn-block mt-5 mb-1" v-on:click="continueToNextChap" :disabled="processingApi">
                                    Continuar
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="processingApi"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="container-fluid question content-desktop">
            <div :class="template.style.surveyBackground ? 'text-white' : 'text-dark'" class="container container-content border-left-light pt-2 pb-5">
                <div class="row">
                    <div v-if="currentReq.questions[0].type != 9" class="col-lg-6 px-lg-5">
                        <h4 v-if="nomeTwo && this.$store.state.project.ownerId == 54" :style="template.style.surveyTitleColor ? {color: template.style.surveyTitleColor} : ''" class="bold t-1 padding-desk">
                            Olá, {{ nomeTwo }}!
                        </h4>
                        <h4 v-else :style="template.style.surveyTitleColor ? {color: template.style.surveyTitleColor} : ''" class="bold t-1 padding-desk">
                            {{ chapTitle }}
                        </h4>
                        <p v-if="survey.id != 552" class="light" :style="template.style.surveyBgColor ? {color: template.style.secondColor} : ''">{{ chapSubTitle }}</p>
                        <p v-else class="light" :style="template.style.surveyTitleColor ? {color: template.style.surveyTitleColor} : ''">{{ chapSubTitle }}</p>
                        <h3 :style="template.style.surveyTitleColor ? {color: template.style.surveyTitleColor} : ''" class="text-survey-color extra-bold text-uppercase">
                            {{ chapName }}
                        </h3>
                        <p v-if="survey.id != 552" :style="template.style.surveyBgColor ? {color: template.style.secondColor} : ''">{{ chapMsg }}</p>
                        <p v-else :style="template.style.surveyTitleColor ? {color: template.style.surveyTitleColor} : ''">{{ chapMsg }}</p>
                    </div>

                    <div
                      class="px-lg-5"
                      :class="[
                        currentReq.questions[0].type === 9 || currentReq.questions[0].type === 12
                          ? 'pt-2 pt-lg-5'
                          : 'pt-5',
                        currentReq.questions[0].type === 9 || currentReq.questions[0].type === 12
                          ? 'col-lg-12'
                          : 'col-lg-6',
                      ]"
                    >
                        <div class="row">
                            <div class="col-12 question-navegation">
                                <div id="pbbar" />
                                <div v-if="allQuestions > 1">
                                    <div :style="template.style.bgProgressBar ? {backgroundColor: template.style.bgProgressBar } : ''" class="progress mb-3">
                                        <div class="progress-bar" role="progressbar" :style="progressStyle" :aria-valuenow="percentDone" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <p :style="template.style.surveyBgColor ? {color: template.style.firstColor } : {color: 'black'}" class="percent d-inline">{{ percentDone }}{{ $t('completed_percentage') }}</p>

                                    <p class="pull-right mb-2 small">
                                        <button class="btn btn-primary px-2 py-2 pt-0 pb-1" style="font-size: 1rem; font-weight: bold;" v-on:click="gonext" v-show="showNextReq" :disabled="processingApi">
                                            <small :style="template.style.surveyBgColor ? {color: template.style.btnTextColor } : ''"> {{ $t('advance') }} </small>
                                        </button>
                                    </p>
                                    <p class="pull-right mr-2">
                                        <button class="btn btn-primary px-2 py-2 pt-0 pb-1" style="font-size: 1rem;" v-on:click="goback" v-show="showPrevReq">
                                            <small :style="template.style.surveyBgColor ? {color: template.style.btnTextColor } : ''"> {{ $t('back') }} </small>
                                        </button>
                                    </p>
                                </div>
                                <div class="mt-4">
                                    <vs-alert v-if="errors.length" class="mb-3 mt-2" :active="inputInvalid">
                                        <b>Aviso :</b>
                                        <ul class="common-list">
                                            <li v-for="error in errors" :key="error.questid">
                                                <span style="white-space: pre-line;">{{ fillString(error.msg) }}</span>
                                            </li>
                                        </ul>
                                    </vs-alert>
                                    <div v-if="hasMandatory">
                                        <div>
                                            <questionYesNo :questionText="fillString(mandatorytext)" :questionId="mandatoryid" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="mandatoryid"></questionYesNo>
                                        </div>
                                        <div v-show="showReqs">
                                            <div v-for="quest in filteredQuestions" v-bind:key="quest.id">
                                                <questionText v-if="quest.type == 1" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :mandatoryQuestion="quest.mandatory" :placeHolder="quest.placeHolder" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionText>
                                                <questionDate v-if="quest.type == 2" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></questionDate>
                                                <questionList v-if="quest.type == 3" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="fillOptions(quest.options)" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionList>
                                                <questionYesNo v-if="quest.type == 4" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionYesNo>
                                                <questionButtonList v-if="quest.type == 5" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="fillOptions(quest.options)" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionButtonList>
                                                <questionAddress v-if="quest.type == 6" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :config="quest.config" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionAddress>
                                                <questionEmail v-if="quest.type == 7" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :placeHolder="quest.placeHolder" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></questionEmail>
                                                <questionMultiText v-if="quest.type == 8" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :placeHolder="quest.placeHolder" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></questionMultiText>
                                                <imageGallery v-if="quest.type == 9" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></imageGallery>
                                                <Telephone v-if="quest.type == 11" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></Telephone>
                                                <cpfQuestion v-if="quest.type == 10" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></cpfQuestion>
                                                <videoGallery v-if="quest.type === 12" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></videoGallery>
                                                <questionChilds v-if="quest.type == 100" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionChilds>
                                                <dependents v-if="quest.type == 13" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></dependents>
                                                <nps v-if="quest.type == 14" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></nps>
                                                <upload v-if="quest.type === 15" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></upload>
                                                <promptMediaQuestion v-if="quest.type == 16" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :placeHolder="quest.placeHolder" :mandatoryQuestion="quest.mandatory" :options="quest.options ? fillOptions(quest.options) : null" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></promptMediaQuestion>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="quest in currentReqQuestions" v-bind:key="quest.id">
                                            <questionText v-if="quest.type == 1" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :placeHolder="quest.placeHolder" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionText>
                                            <questionDate v-if="quest.type == 2" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></questionDate>
                                            <questionList v-if="quest.type == 3" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="fillOptions(quest.options)" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionList>
                                            <questionYesNo v-if="quest.type == 4" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionYesNo>
                                            <questionButtonList v-if="quest.type == 5" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionButtonList>
                                            <questionAddress v-if="quest.type == 6" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :config="quest.config" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionAddress>
                                            <questionEmail v-if="quest.type == 7" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :placeHolder="quest.placeHolder" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></questionEmail>
                                            <questionMultiText v-if="quest.type == 8" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :placeHolder="quest.placeHolder" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></questionMultiText>
                                            <imageGallery v-if="quest.type == 9" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></imageGallery>
                                            <Telephone v-if="quest.type == 11" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></Telephone>
                                            <cpfQuestion v-if="quest.type == 10" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" :mandatoryQuestion="quest.mandatory" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></cpfQuestion>
                                            <videoGallery v-if="quest.type === 12" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></videoGallery>
                                            <questionChilds v-if="quest.type == 100" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></questionChilds>
                                            <dependents v-if="quest.type == 13" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></dependents>
                                            <nps v-if="quest.type == 14" :questionText="fillQuestionText(quest.text)" :questionId="quest.id" :options="quest.options" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></nps>
                                            <upload v-if="quest.type === 15" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :options="quest.options" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" :key="quest.id"></upload>
                                            <promptMediaQuestion v-if="quest.type == 16" :questionText="fillQuestionText(quest.text)" :questionObs="quest.obs" :questionId="quest.id" :placeHolder="quest.placeHolder" :mandatoryQuestion="quest.mandatory" :options="quest.options ? fillOptions(quest.options) : null" :config="quest.config" @QuestionAnwered="QuestionAnwered" @AnswerChanged="AnswerChanged" @ErrorOccured="ErrorOccured" :key="quest.id"></promptMediaQuestion>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 offset-md-3">
                                <!-- <button type="submit" class="btn btn-primary d-flex mt-5 mb-5">Ok</button> -->
                                <div v-if="getShowBtnOk">
                                    <div class="form-group">
                                        <button type="button" class="btn btn-primary btn-block mt-5 mb-5" :style="template.style.surveyBgColor ? {color: template.style.btnTextColor } : ''" v-on:click="submit" v-show="getShowBtnOk" :disabled="processingApi">
                                            <span v-if="!showCountDown"> {{ LabelBtn }} </span>
                                            <span class="mr-2" v-if="showCountDown"> {{ countDown }} </span>
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="processingApi"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import QT from "./1_TextQuestion.vue";
import QD from "./2_DateQuestion.vue";
import IL from "./3_InputListQuestion.vue";
import QYN from "./4_YesNoQuestion.vue";
import BTL from "./5_ButtonListQuestion.vue";
import ADR from "./6_Address.vue";
import EMAIL from "./7_Email.vue";
import MTXT from "./8_MultiText.vue";
import IMGGAL from "./9_ImageGallery.vue";
import CPF from "./10_CpfQuestion.vue";
import TEL from "./11_Telephone.vue";
import videoGallery from "./12_VideoGallery";
import dependents from "./13_Dependents";
import nps from "./14_NpsQuestion";
import upload from "./15_uploadFile";
import PROMPT_MEDIA from "./16_PromptMediaQuestion.vue";
import CHILDS from "./100_Childs.vue";
import CC from "./ChapCard.vue";
import ECC from "./EndChapCard.vue";
import preventBack from "vue-prevent-browser-back";
import {
    getDocumentErrorMessage,
    getDocumentRule,
    isDocumentAnswerValid
} from "./documentRules";
import { getFinalSurveyRoute } from "../../utils/finalSurveyRoute";

import {
    Survey
} from "../../services/Survey.js";
const s = new Survey();

export default {
    mixins: [preventBack],
    name: "SmartSurvey",
    data: () => ({
        processingApi: false,
        ansChanged: false,
        index: 3,
        currentChapter: {},
        currentReq: {},
        chapId: 0,
        percent: 0.0,
        percentChap: 0.0,
        mudouChap: false,
        fimChap: false,
        fimSurvey: false,
        answerData: [],
        errors: [],
        qtErros: 0,
        mandatoryid: 0,
        countDown: 5,
        showCountDown: false,
        mandatorytext: 0,
        hasMandatory: false,
        showReqs: false,
        showBtnOk: false,
        showNextReq: true,
        showPrevReq: true,
        inputInvalid: false,
        btnLabel: "",
    }),
    components: {
        questionButtonList: BTL,
        questionYesNo: QYN,
        questionText: QT,
        questionDate: QD,
        questionList: IL,
        questionAddress: ADR,
        questionEmail: EMAIL,
        questionMultiText: MTXT,
        questionChilds: CHILDS,
        imageGallery: IMGGAL,
        "chap-card": CC,
        "endchap-card": ECC,
        cpfQuestion: CPF,
        Telephone: TEL,
        videoGallery,
        dependents,
        nps,
        upload,
        promptMediaQuestion: PROMPT_MEDIA
    },
    computed: {
        LabelBtn() {
            if (this.processingApi) return "Aguarde...";
            else return this.btnLabel;
        },
        survey() {
            return this.$store.state.template.survey;
        },
        nome() {
          var socialName = this.fillStringName("<@RQ:141@>");
          var n = this.fillStringName("<@RQ:101@>");
          if (socialName && socialName != "undefined") return socialName;
          return n;
        },
        nomeTwo() {
          return this.$store.state.nomeTwo;
        },
        inputInvalid_old() {
            /*
                                 var ok = false;
                                 if (this.errors) {
                                    if (this.errors.length > 0)
                                        ok = true;
                                return ok;
                                }*/

            if (this.qtErros == 0) return false;
            else return true;
        },
        getShowBtnOk() {
            const firstQuestion = this.currentReqQuestions[0];
            if (firstQuestion && firstQuestion.type === 10) {
                return true;
            } else {
                if (this.hasMandatoryUnanswered) {
                    return false
                } else {
                    return this.showBtnOk;
                }
            }
        },
        hasMandatoryUnanswered() {
            return (this.hasMandatory && !this.showReqs)
        },
        filteredQuestions() {
            var fq = [];
            for (var m = 0; m < this.currentReq.questions.length; m++) {
                if (!this.currentReq.questions[m].mandatoryReq) {
                    fq.push(this.currentReq.questions[m]);
                }
            }
            return fq;
        },
        currentReqQuestions() {
            return this.currentReq.questions || [];
        },
        sstruct: function () {
            return this.currentChapter;
        },
        getImage: function () {
            var s = "static/assets/img/" + this.currentChapter.id + ".png";
            return s;
        },
        chapName: function () {
            var s = "";
            if (this.currentChapter.name)
                s = this.fillString(this.currentChapter.name);
            return s;
        },
        chapTitle: function () {
            var s = "";
            if (this.currentChapter.title)
                s = this.fillString(this.currentChapter.title);
            return s;
        },
        chapSubTitle: function () {
            var s = "";
            if (this.currentChapter.subTitle)
                s = this.fillString(this.currentChapter.subTitle);
            return s;
        },
        chapMsg: function () {
            var s = "";
            if (this.currentChapter.introMessage)
                s = this.fillString(this.currentChapter.introMessage);
            return s;
        },
        endName: function () {
            var s = "";
            if (this.currentChapter.endLabel)
                s = this.fillString(this.currentChapter.endLabel);
            return s;
        },
        endTitle: function () {
            var s = "";
            if (this.currentChapter.endTitle)
                s = this.fillString(this.currentChapter.endTitle);
            return s;
        },
        endSubTitle: function () {
            var s = "";
            if (this.currentChapter.endSubTitle)
                s = this.fillString(this.currentChapter.endSubTitle);
            return s;
        },
        nomeTwo() {
          return this.$store.state.nomeTwo;
        },
        endMsg: function () {
            var s = "";
            if (this.currentChapter.endMessage)
                s = this.fillString(this.currentChapter.endMessage);
            return s;
        },
        allQuestions() {
            let sum = 0;
            this.$store.state.surveyStruct.chapters.forEach((e) => {
                sum += e.requirements.length;
            });
            return sum;
        },
        progressStyle: function () {
            var p = 0;
            if (this.percentDone > 100) p = 100;
            else p = this.percentDone;

            return "width: " + p + "%;";
        },
        percentDone: function () {
            let questionsSum = 0;
            this.$store.state.surveyStruct.chapters.forEach((chap) => {
                if (chap.id < this.currentChapter.id) {
                    questionsSum += chap.requirements.length;
                } else if (chap.id === this.currentChapter.id) {
                    chap.requirements.forEach((req) => {
                        if (req.id < this.currentReq.id) questionsSum++;
                    });
                }
            });
            if (questionsSum > this.allQuestions) return 100;
            else return Math.ceil((questionsSum / this.allQuestions) * 100);
        },
        progressStyleCap: function () {
            var p = 0;
            if (this.percentChap > 100) p = 100;
            else p = this.percentChap;

            return "width: " + p + "%;";
        },
        percentCap: function () {
            if (this.percentChap > 100) return 100;
            else return this.percentChap;
        },
        template() {
            return this.$store.state.template;
        },
        survStruct() {
            return this.$store.state.surveyStruct;
        },
        nome() {
          var socialName = this.fillString("<@RQ:141@>");
          var n = this.fillString("<@RQ:101@>");
          if (socialName && socialName != "undefined") return socialName;
          return n;
        },
        // showPrevBtn() {
        //   // this computed property is used to disable the "prevReq" nav's button
        //   // if the user is on the first requirement of the second chapter.
        //   // The purpose is to not allow the user to change info of his registration.
        //   if (!this.currentChapter || this.survStruct.chapters.length < 2)
        //     return true;
        //   let isSecondChapter =
        //     this.currentChapter.code == this.survStruct.chapters[1].code;
        //   let isFirstReq =
        //     this.currentReq.code ==
        //     this.survStruct.chapters[1].requirements[0].code;
        //   if (isSecondChapter && isFirstReq) return false;
        //   return true;
        // },
    },
    methods: {
        invalidEmailMessage() {
            return this.survey && String(this.survey.iso3).toUpperCase() === "FRA"
                ? "Email invalide"
                : "Email inválido";
        },
        shouldGoToFinalSurvey(ret) {
            return ret &&
                ret.surveyEnded === true &&
                ret.surveyStruct &&
                Array.isArray(ret.surveyStruct.chapters) &&
                ret.surveyStruct.chapters.length === 0;
        },
        goToFinalSurvey(ret) {
            const surveyType = ret && ret.surveyStruct ? ret.surveyStruct.type : null;
            const route = getFinalSurveyRoute(this.$store.state.template, surveyType);
            this.$router.push(route).catch(() => {});
        },
        usesFinalSurveyFromAPI() {
            return !!this.$store.state.template?.finalSurveyFromAPI;
        },
        navigateToFinalSurveyScreen() {
            window.scrollTo(0, 0);
            const route = getFinalSurveyRoute(
                this.$store.state.template,
                this.$store.state.surveyStruct.type
            );
            this.$router.push(route).catch(() => {});
        },
        finishSurveyFlow() {
            if (this.usesFinalSurveyFromAPI()) {
                this.navigateToFinalSurveyScreen();
                return;
            }

            s.EndSurvey(this.$store.state.surveyUserId).then(
                (ret) => {
                    this.$store.dispatch("set_endSurvey", ret.data);
                    if (ret) {
                        if (ret.header?.codigo === 1 && ret.header?.msg === "redirect") {
                            window.location.href = ret.data;
                        } else {
                            this.navigateToFinalSurveyScreen();
                        }
                    }
                },
                (err) => alert(err)
            );
        },
        fillQuestionText(s) {
            s = this.fillString(s);
            return s;
        },
        fillOptions(o) {
            for (var i = 0; i < o.length; i++) o[i].text = this.fillString(o[i].text);

            return o;
        },
        fillStringName(s) {
          if (s.includes("<@") && s.includes("@>")) {
            var s1 = s.split("<@");
            var s2 = s1[1].split("@>");
            var s3 = s2[0].split(":");
            var rid = s3[1];
            const value = this.$store.state.answers[rid];
            s = s1[0] + value + s2[1];
          }
          return s;
        },
        fillString(s) {
            while (s.includes("<@") && s.includes("@>")) {
                let s1 = s.split("<@");
                let s2 = s1[1].split("@>");
                let s3 = s2[0].split(":");
                let rid = s3[1];
                let value = ''
                if (this.$store.state.answers[rid]) {
                    value = this.$store.state.answers[rid];
                }
                value = value.replace(";", "");
                s = s1[0] + value + s2[1];
            }
            while (s.includes("<#") && s.includes("#>")) {
                let s1 = s.split("<#");
                const code = s1[1].split("#>")[0];

                let value = "";
                if (code.includes("/")) {
                    const genderProp = code.split(":")[0];
                    const options = code.split(":")[1].split("/");
                    const gender = this.$store.state.template.nouns[genderProp];
                    value = options[gender];
                } else {
                    value = this.$store.state.template.nouns[code];
                }

                s = s
                    .replace(code, value)
                    .replace("<#", "")
                    .replace("#>", "");
            }
            return s;
        },
        ErrorOccured(value, id) {
            var payload = {
                questid: id,
                msg: value
            };
            if (this.errors) {
                var found = false;
                for (var i = 0; i < this.errors.length; i++) {
                    if (this.errors[i].questid == id) {
                        this.errors[i] = payload;
                        found = true;
                    }
                }
                if (!found) {
                    this.errors.push(payload);
                    this.qtErros++;
                }
            } else {
                this.qtErros++;
                this.errors.push(payload);
            }
        },
        RemoveError(id) {
            if (this.errors)
                for (var i = 0; i < this.errors.length; i++) {
                    if (this.errors[i].questid == id) {
                        this.errors.splice(i, 1);
                        this.qtErros--;
                    }
                }

            if (this.errors.length == 0) {
                this.errors = [];
                this.qtErros = 0;
                this.inputInvalid = false;
            }
        },
        AnswerChanged(value, id) {
            this.ansChanged = true;
            var payload = {
                questid: id,
                value: value
            };
            this.RemoveError(id);
            this.$store.commit("SET_Answer", payload);
        },
        QuestionAnwered(value, id) {
            this.ansChanged = true;
            if (this.hasMandatory) {
                if (id == this.mandatoryid) {
                    if (value == "Sim") this.showReqs = true;
                    else this.showReqs = false;
                }
            }

            this.RemoveError(id);

            var payload = {
                questid: id,
                value: value
            };
            this.$store.commit("SET_Answer", payload);

            if (this.hasMandatory) {
                if (id == this.mandatoryid) {
                    if (value != "Sim") this.saveAnswers();
                } else {
                    //aqui
                    if (this.checkReqComplete()) this.saveAnswers();
                }
            } else {
                if (this.checkReqComplete()) this.saveAnswers();
            }
        },
        goback() {
            this.prevReq();
        },
        gonext() {
            if (this.checkReqComplete()) {
                if (this.ansChanged) {
                    this.submit();
                } else {
                    this.nextReq(true);
                }
            } else {
                if (this.qtErros != 0) this.inputInvalid = true;
            }
        },
        submit() {
            //verificar se todo o quesito foi respondido
            if (this.checkReqComplete()) {
                if (this.qtErros == 0) {
                    this.inputInvalid = false;
                    this.saveAnswers();
                }
            } else {
                if (this.qtErros != 0) {
                    this.inputInvalid = true;
                }
                if (this.fimChap) window.scrollTo(0, 0);
                else {
                    var element = document.getElementById("pbbar");
                    element.scrollIntoView();
                }
            }
        },
        checkReqComplete: function () {
            var ok = false;
            var qtOk = 0;
            //se mandatoryreq e nao, ok
            var manswer = this.$store.getters.answerValue(this.mandatoryid);

            if (this.hasMandatory && manswer == "Não") {
                ok = true;
            } else {
                for (var i = 0; i < this.currentReq.questions.length; i++) {
                    var qid = this.currentReq.questions[i].id;
                    //const countAnwsers = this.$store.state.answers.filter(item => item.questid === qid).length
                    if (this.$store.state.answers[qid] || (this.$store.state.answers[qid] == "" && (this.currentReq.questions[i].type == 1 || (this.currentReq.questions[i].type == 16 && !this.currentReq.questions[i].options)) && this.currentReq.questions[i].mandatory == false)) {
                        if (this.$store.state.answers[qid] != "" || this.currentReq.questions[i].mandatory == false) {
                            if (
                                this.errors.some(
                                    (e) => e.msg.startsWith("Data") || e.msg.startsWith("Email")
                                )
                            ) {
                                this.inputInvalid = true;
                            } else {
                                if (getDocumentRule(qid) && !isDocumentAnswerValid(this.$store.state.answers[qid], qid)) {
                                    this.ErrorOccured(
                                        getDocumentErrorMessage(qid),
                                        qid
                                    );
                                } else
                                if (qid == 143 && this.$store.state.answers[qid].length < 2 && this.currentReq.questions[i].mandatory === true) {
                                    this.ErrorOccured(
                                        "Informe corretamente: " +
                                        this.currentReq.questions[i].text,
                                        qid
                                    );
                                } else
                                if (qid === 103) {
                                    if (this.$store.state.answers[qid].length >= 5) {
                                        if (this.$store.state.answers[qid].includes("@") &&
                                            this.$store.state.answers[qid].includes(".") &&
                                            !this.$store.state.answers[qid].endsWith(".")
                                        ) {
                                            this.RemoveError(qid);
                                            qtOk++;
                                        } else {
                                            this.ErrorOccured(
                                                this.invalidEmailMessage(),
                                                qid
                                            );
                                        }
                                    } else {
                                        this.ErrorOccured(
                                            this.invalidEmailMessage(),
                                            qid
                                        );
                                    }
                                } else
                                if (qid == 104 && this.$store.state.answers[qid]) {
                                    let s = this.$store.state.answers[qid].split("/");
                                    let day = parseInt(s[0], 10);
                                    let month = parseInt(s[1], 10);
                                    let year = parseInt(s[2], 10);
                                    let currentYear = new Date().getFullYear();
                                    let minYear = currentYear - 112;

                                    if (isNaN(day) || isNaN(month) || isNaN(year) || s.length !== 3) {
                                        this.ErrorOccured(
                                            "Data informada incorreta.",
                                            qid
                                        );
                                    } else if (month < 1 || month > 12) {
                                        this.ErrorOccured(
                                            "Mês informado incorreto.",
                                            qid
                                        );
                                    } else if (day < 1 || day > 31) {
                                        this.ErrorOccured(
                                            "Dia informado incorreto.",
                                            qid
                                        );
                                    } else if (year < minYear || year > currentYear) {
                                        this.ErrorOccured(
                                            "Ano informado incorreto.",
                                            qid
                                        );
                                    } else {
                                        let d = new Date(year, month - 1, day);
                                        let today = new Date();
                                        today.setHours(0, 0, 0, 0);
                                        d.setHours(0, 0, 0, 0);

                                        if (
                                            d.getFullYear() !== year ||
                                            d.getMonth() !== month - 1 ||
                                            d.getDate() !== day
                                        ) {
                                            this.ErrorOccured(
                                                "Data informada incorreta.",
                                                qid
                                            );
                                        } else if (d > today) {
                                            this.ErrorOccured(
                                                "A data não pode ser futura.",
                                                qid
                                            );
                                        } else {
                                            this.RemoveError(qid);
                                            qtOk++;
                                        }
                                    }
                                } else
                                if (qid == 107 && this.$store.state.answers[qid]) {
                                    let answerCep = JSON.parse(this.$store.state.answers[qid])
                                    if (
                                        this.$store.state.answers[qid] == true ||
                                        (answerCep.cep == "00000-000" && this.currentReq.questions[i].mandatory === true)
                                    ) {
                                        this.ErrorOccured(
                                            "Informe corretamente o seu CEP",
                                            qid
                                        );
                                        this.inputInvalid = true;
                                    } else {
                                        this.RemoveError(qid);
                                        qtOk++;
                                    }
                                } else
                                if (this.currentReq.questions[0].type === 13) {
                                    let qtdChilds = this.$store.state.answers[qid].split(";")[0];
                                    let idade = this.$store.state.answers[qid].substr(1).split(";");
                                    let idadeValid = false;
                                    for (let i = 1; i <= qtdChilds; i++) {
                                        idade[i] = idade[i].substr(0, 1);
                                        if (isNaN(idade[i]) || idade[i] == 0) {
                                            idadeValid = true;
                                        }
                                    }
                                    if (idadeValid != false) {
                                        this.ErrorOccured(
                                            "Preencha o campo de idade para prosseguir"
                                        );
                                    } else {
                                        this.RemoveError(qid);
                                        qtOk++;
                                    }
                                } else {
                                    if (Number(this.currentReq.questions[i].type) === 16) {
                                        const quest = this.currentReq.questions[i];
                                        const hasOptions = Array.isArray(quest.options) && quest.options.length > 0;

                                        if (hasOptions) {
                                            this.RemoveError(qid);
                                            qtOk++;
                                        } else {
                                        const answer = String(this.$store.state.answers[qid] || "").trim();
                                        const isMandatory = quest.mandatory !== false;
                                        const isTooShort = answer.length <= 2;

                                        if ((isMandatory && isTooShort) || (!isMandatory && answer.length > 0 && isTooShort)) {
                                            this.ErrorOccured(
                                                "Informe corretamente: " +
                                                quest.text,
                                                qid
                                            );
                                        } else {
                                            this.RemoveError(qid);
                                            qtOk++;
                                        }
                                        }
                                    } else if (qid == 119) {
                                        let isValid = this.checkCPF(this.$store.state.answers[qid]);
                                        if (!isValid) {
                                            this.ErrorOccured(
                                                "Informe corretamente: " +
                                                this.currentReq.questions[i].text,
                                                qid
                                            );
                                        } else {
                                            this.RemoveError(qid);
                                            qtOk++;
                                        }
                                    } else {
                                        this.RemoveError(qid);
                                        qtOk++;
                                    }
                                }
                            }
                        } else {
                            if (!this.currentReq.questions[i].mandatory) {
                                this.RemoveError(qid);
                                qtOk++;
                            }
                            this.ErrorOccured(
                                `${this.$t("reply")}:\n${this.currentReq.questions[i].text}`,
                                qid
                            );
                        }
                    } else {
                        if (!this.currentReq.questions[i].mandatory) {
                            this.RemoveError(qid);
                            qtOk++;
                        }
                        this.ErrorOccured(
                            `${this.$t("reply")}:\n${this.currentReq.questions[i].text}`,
                            qid
                        );
                    }
                }
                if (qtOk == this.currentReq.questions.length) {
                    ok = true;
                    this.qtErros = 0;
                    this.errors = [];
                }
            }
            return ok;
        },
        saveAnswers() {
            this.index = this.index - 1;
            var ans = [];
            this.processingApi = true;
            for (var i = 0; i < this.currentReq.questions.length; i++) {
                var pid = this.currentReq.questions[i].id;
                var answer = this.$store.state.answers[pid];
                if (answer !== undefined && answer !== null && answer !== "") {
                    ans.push({
                        questionId: pid,
                        answer: String(answer).trim(),
                    });
                }
            }
            s.SaveAnswers(
                this.$store.state.surveyUserId,
                this.$store.state.currentReq,
                this.$store.state.currentChapter,
                ans
            ).then(
                (ret) => {
                    if (ret) {
                        this.index = 3;
                        this.nextReq(false);
                    }
                },
                (err) => {
                    if (this.index > 0) {
                        this.saveAnswers();
                    } else {
                        if (this.index == 0) {
                            setTimeout(() => {
                                this.saveAnswers();
                            }, 2000);
                        } else if (this.index < 0) {
                            this.$vs.notify({
                                color: "RGBA(255,0,0)",
                                title: `Atenção!`,
                                text: `Não foi possível salvar a resposta. Por favor, aguarde um momento e tente novamente.`,
                                time: 5000
                            });
                            this.showCountDown = true;
                            setTimeout(() => {
                                this.processingApi = false;
                                this.showCountDown = false;
                            }, 5000);
                            this.countDownDesc()
                        } else {
                            this.index = 3;
                            this.processingApi = false;
                            alert(err);
                        }
                    }
                }
            );
        },
        countDownDesc() {
            const intervalo = setInterval(() => {
                if (this.countDown > 0) {
                    this.countDown--;
                } else {
                    clearInterval(intervalo);
                    this.countDown = 5;
                }
            }, 1000);
        },
        saveAnswer() {
            s.AddAnswer(this.$store.state.surveyUserId, 1, this.answerData[0]).then(
                (ret) => {
                    if (ret) {
                        this.answerData = [];
                        this.nextReq(false);
                    }
                },
                (err) => alert(err)
            );
        },
        checkMandatory() {
            this.hasMandatory = false;
            this.showReqs = false;
            for (var m = 0; m < this.currentReq.questions.length; m++) {
                if (this.currentReq.questions[m].mandatoryReq) {
                    this.mandatoryid = this.currentReq.questions[m].id;
                    this.mandatorytext = this.currentReq.questions[m].text;
                    this.hasMandatory = true;
                    break;
                }
            }

            if (this.hasMandatory) {
                var manswer = this.$store.getters.answerValue(this.mandatoryid);
                if (manswer == "Sim") {
                    this.showReqs = true;
                }
            }
        },
        continueToNextChap() {
            if (this.currentChapter.surveyId) {
                this.changeSurvey();
                this.percent = 0;
                this.mudouChap = !this.mudouChap;
                this.errors = [];
                this.inputInvalid = false;
            } else {
                this.getChapter();
                this.nextChapter();
                this.percent = 0;
                this.fimChap = false;
                this.mudouChap = !this.mudouChap;
                this.errors = [];
                this.inputInvalid = false;
            }
        },
        checkCond(cond, valToCheck, valueCond) {
            var resp = false;
            var values;
            var resps;
            var i;
            var r;

            if (cond === "=|") {
                resp = false;
                values = valueCond.split("/#");
                resps = valToCheck.split(";");
                for (r = 0; r < resps.length; r++) {
                    if (resp) break;
                    for (i = 0; i < values.length; i++) {
                        if (resps[r] == values[i]) resp = true;
                    }
                }
            }

            if (cond == "!&") {
                resp = true;
                values = valueCond.split("/#");
                resps = valToCheck.split(";");
                for (r = 0; r < resps.length; r++) {
                    for (i = 0; i < values.length; i++) {
                        if (resps[r] == values[i]) resp = false;
                    }
                }
            }

            if (cond == "=") {
                resp = false;
                if (valToCheck.includes(";")) {
                    resps = valToCheck.split(";");
                    for (r = 0; r < resps.length; r++) {
                        if (resps[r] == valueCond) {
                            resp = true;
                            break;
                        }
                    }
                } else if (valToCheck == valueCond) resp = true;
            }

            if (cond == "!") {
                resp = true;
                if (valToCheck.includes(";")) {
                    resps = valToCheck.split(";");
                    for (r = 0; r < resps.length; r++) {
                        if (resps[r] == valueCond) {
                            resp = false;
                            break;
                        }
                    }
                } else {
                    if (valToCheck == "") resp = true;
                    else if (valToCheck != valueCond) resp = true;
                    else resp = false;
                }
            }

            return resp;
        },
        checkSkip(skipCconfig) {
            var skip = false;

            if (skipCconfig.includes("--")) {
                var listaCond = skipCconfig.split("--");

                for (var cl = 1; cl < listaCond.length; cl++) {
                    // 0: numero da pergunta, 1: condição 2: valor

                    var condl = listaCond[cl].split(",");
                    var reqidl = condl[0];
                    var vall = "";

                    if (!this.$store.state.answers[reqidl]) vall = "";
                    else vall = this.$store.state.answers[reqidl];

                    skip = skip || this.checkCond(condl[1], vall, condl[2]);
                }
            } else {
                // 1: numero da pergunta, 2: condição 3: valor
                let cond = skipCconfig.split(",");
                const reqid = cond[1];
                let aswr = "";

                if (!this.$store.state.answers[reqid]) aswr = "";
                else aswr = this.$store.state.answers[reqid];

                skip = this.checkCond(cond[2], aswr, cond[3]);
            }
            return skip;
        },
        prevReq() {
            var i;
            var skip = false;
            var inicio = 0;
            var changedCap = false;
            this.showBtnOk = false;
            this.errors = [];
            this.inputInvalid = false;
            //verificar se estamos no inicio do cápitulo
            var ii;
            for (ii = this.currentChapter.requirements.length - 1; ii >= 0; ii--) {
                var cc = this.currentChapter.requirements[ii];
                if (cc.id == this.currentReq.id) {
                    //achei o req
                    var nex = this.currentChapter.requirements[ii - 1];
                    if (!nex) {
                        //inicio do capitulo

                        if (this.currentChapter.id > 1) {
                            var c = this.$store.state.surveyStruct.chapters;
                            this.currentChapter = c[this.currentChapter.id - 2];
                            inicio = this.currentChapter.requirements.length - 1;
                            this.chapId = this.currentChapter.id;
                            this.$store.commit("SET_Chapter", this.currentChapter.id);
                            this.currentReq = this.currentChapter.requirements[
                                this.currentChapter.requirements.length - 1
                            ];
                            changedCap = true;
                        }
                    } else {
                        inicio = ii;
                        break;
                    }
                }
            }

            if (inicio == 0) inicio = this.currentChapter.requirements.length - 1;

            for (i = inicio; i >= 0; i--) {
                var r = this.currentChapter.requirements[i];

                if (
                    (r.id = this.currentReq.id) ||
                    (r.id < this.currentReq.id && skip) ||
                    changedCap
                ) {
                    var nextr;

                    if (changedCap) {
                        changedCap = false;
                        nextr = r;
                    } else {
                        nextr = this.currentChapter.requirements[i - 1];
                    }

                    skip = false;

                    if (nextr.config) {
                        //Check skip

                        if (nextr.config.includes("skip")) {
                            //procurar o skip dentro do config

                            var cnf = nextr.config.split(";");
                            for (var ci = 0; ci < cnf.length; ci++) {
                                if (cnf[ci].includes("skip")) {
                                    skip = this.checkSkip(cnf[ci]);
                                    break;
                                }
                            }
                        }
                    }

                    this.currentReq = nextr;
                    this.$store.commit("SET_Req", this.currentReq.id);

                    if (this.chapId == 1)
                        if (i == 1) this.showPrevReq = false;

                    if (!skip) break;
                }
            }

            this.checkMandatory();
            this.showBtnOk = false;

            if (this.currentReq.config)
                if (this.currentReq.config.includes("btnok")) {
                    this.showBtnOk = true;
                }

            this.ansChanged = false;
            this.showNextReq = true;
        },
        nextReq(nav) {
            var i;
            var skip = false;
            this.showBtnOk = false;
            this.errors = [];
            this.inputInvalid = false;
            this.processingApi = false

            this.checkTheGoToConfig()

            for (i = 0; i < this.currentChapter.requirements.length; i++) {
                var r = this.currentChapter.requirements[i];
                if (r.id == this.currentReq.id || (r.id > this.currentReq.id && skip)) {
                    if (i + 1 == this.currentChapter.requirements.length) {
                        const s = this.$store.state.surveyStruct;
                        var c = s.chapters;

                        if (nav) {
                            //Se for o último capitulo deixar.
                            if (this.currentChapter.id == c.length) {
                                this.fimSurvey = false;
                                this.nextChapter();
                            } else {
                                this.fimChap = false;
                                this.nextChapter();
                                break;
                            }
                        } else {
                            if (this.endMsg && this.endMsg.length > 0 || this.endTitle && this.endTitle.length > 0 || this.endName && this.endName.length > 0) {
                                this.fimChap = true;
                            } else {
                                this.continueToNextChap();
                            }
                        }
                    } else {
                        var nextr = this.currentChapter.requirements[i + 1];
                        skip = false;
                        if (nextr.config) {
                            if (nextr.config.includes("skip")) {
                                //procurar o skip dentro do config
                                var cnf = nextr.config.split(";");
                                for (var ci = 0; ci < cnf.length; ci++) {
                                    if (cnf[ci].includes("skip")) {
                                        skip = this.checkSkip(cnf[ci]);
                                        break;
                                    }
                                }
                            }
                        }
                        if (!skip) {
                            this.showPrevReq = true;
                            this.currentReq = nextr;
                            this.$store.commit("SET_Req", this.currentReq.id);
                            if (this.currentReq.id > this.$store.state.lastReq) {
                                this.$store.commit("SET_LastReq", this.currentReq.id);
                                this.percent = Math.ceil(
                                    ((i + 1) / this.currentChapter.requirements.length) * 100
                                );
                            }
                            break;
                        }
                    }
                }
            }

            if (this.fimSurvey && !this.currentChapter.surveyId) {
                const route = getFinalSurveyRoute(
                    this.$store.state.template,
                    this.$store.state.surveyStruct.type
                );
                this.$router.push(route).catch(() => {});
            }

            this.checkMandatory();

            this.showBtnOk = false;
            if (this.currentReq.config)
                if (this.currentReq.config.includes("btnok")) {
                    this.showBtnOk = true;
                }

            if (this.fimChap) window.scrollTo(0, 0);
            else {
                if (!nav) {
                    var element = document.getElementById("pbbar");
                    element.scrollIntoView();
                }
            }
        },
        checkTheGoToConfig() {
            if (this.currentReq.config) {
                if (this.currentReq.config.includes("goTo")) {
                    const configArray = this.currentReq.config.split(";");
                    const goToConfig = configArray.filter(e => e.startsWith('goTo:'))[0];
                    this.goTo(goToConfig)
                }
            }
        },
        goTo(config) {
            const target = config.split(":")[1];
            const question = config.split(":")[2];
            const operator = config.split(":")[3];
            const answer = config.split(":")[4];

            let conditionsOk = false;

            // check conditions
            if (this.$store.state.answers[Number(question)]) {
                if (operator === '=') {
                    if (this.$store.state.answers[Number(question)] === answer) {
                        conditionsOk = true;
                    }
                } else {
                    if (this.$store.state.answers[Number(question)] !== answer) {
                        conditionsOk = true;
                    }
                }
            }

            // send to target
            if (conditionsOk) {
                if (target === 'final') {
                    if (this.usesFinalSurveyFromAPI()) {
                        this.fimSurvey = true;
                        this.navigateToFinalSurveyScreen();
                        return;
                    }

                    s.EndSurvey(this.$store.state.surveyUserId).then(
                        (ret) => {
                            if (ret.header?.codigo === 1 && ret.header?.msg === "redirect") {
                                window.location.href = ret.data;
                            }
                            else{
                                this.$store.dispatch("set_endSurvey", ret.data);
                            }
                        },
                        (err) => {
                            this.$vs.notify({
                                color: "RGBA(255,0,0)",
                                title: `Ocorreu um erro:`,
                                text: err,
                                time: 5000
                            });
                        }
                    );
                    this.fimSurvey = true;
                }
            }
        },
        getChapter() {
            const s = this.$store.state.surveyStruct;
            var c = s.chapters;
            if (this.$store.state.currentChapter == 0) {
                this.currentChapter = c[0];
                this.$store.commit("SET_Chapter", c[0].id);
                this.chapId = c[0].id;
                this.currentReq = this.currentChapter.requirements[0];
                this.percent = 0;
                this.percentChap = 0;
                this.showPrevReq = false;
            } else {
                var i;
                for (i = 0; i < c.length; i++) {
                    if (c[i].id == this.$store.state.currentChapter) {
                        this.currentChapter = c[i];
                        this.chapId = this.currentChapter.id;
                        break;
                    }
                }
                //get the requirement

                this.percentChap = Math.ceil(((i + 1) / c.length) * 100);

                if (this.$store.state.currentReq == 0) {
                    if (this.currentChapter.requirements != null) {
                        this.currentReq = this.currentChapter.requirements[0];
                        this.$store.commit("SET_Req", this.currentReq.id);
                        this.$store.commit("SET_LastReq", this.currentReq.id);
                        this.showPrevReq = false;
                    }
                    this.percent = 0;
                } else {
                    for (i = 0; i < this.currentChapter.requirements.length; i++) {
                        if (
                            this.currentChapter.requirements[i].id ==
                            this.$store.state.currentReq
                        ) {
                            this.currentReq = this.currentChapter.requirements[i];
                            this.showPrevReq = true;
                            this.percent = Math.ceil(
                                ((i + 1) / this.currentChapter.requirements.length) * 100
                            );
                            break;
                        }
                    }
                }
            }

            this.checkMandatory();

            this.showBtnOk = false;

            if (this.currentReq.config)
                if (this.currentReq.config.includes("btnok")) {
                    this.showBtnOk = true;
                }
            window.scrollTo(0, 0);
        },
        nextChapter() {
            const surv = this.$store.state.surveyStruct;
            var c = surv.chapters;
            for (var i = 0; i < c.length; i++) {
                if (c[i].id == this.$store.state.currentChapter) {
                    //verifica se acabou
                    if (i + 1 == c.length) {
                        this.fimSurvey = true;
                        this.percentChap = 100;
                    } else {
                        this.currentChapter = c[i + 1];
                        this.chapId = this.currentChapter.id;
                        this.$store.commit("SET_Chapter", this.currentChapter.id);
                        if (this.currentChapter != null) {
                            this.currentReq = this.currentChapter.requirements[0];
                            this.$store.commit("SET_Req", this.currentReq.id);
                        }

                        this.percentChap = Math.ceil(((i + 1) / c.length) * 100);
                    }
                    break;
                }
            }

            if (this.fimSurvey) {
                this.finishSurveyFlow();
            } else {
                this.checkMandatory();

                this.showBtnOk = false;
                if (this.currentReq.config)
                    if (this.currentReq.config.includes("btnok")) {
                        this.showBtnOk = true;
                    }
                window.scrollTo(0, 0);
            }
        },
        changeSurvey() {
            this.processingApi = true;
            let params = {}
            if (this.$store.state.answers[104]) {
                params = {
                    confirmationCode: this.$store.state.answers[104]
                }
            }
            s.Start(
                this.$store.state.userId,
                this.$store.state.userPhone,
                this.currentChapter.surveyId,
                this.template.survey.prj,
                params
            ).then(
                (ret) => {
                    this.$store.commit("SET_SurveyStruct", ret.surveyStruct);
                    this.$store.commit("SET_Req", ret.currentReq);
                    this.$store.commit("SET_Chapter", ret.currentChapter);
                    this.$store.commit("SET_SurveyUserId", ret.userSurveyId);
                    this.$store.commit("SET_LastReq", ret.currentReq);
                    this.$store.commit("SET_LastChapter", ret.currentChapter);
                    if (ret.currentReq != 0) {
                        this.$store.commit("SET_StarNextReq", true);
                    }

                    //adicionar as respostas
                    if (ret.answers) {
                        for (var i = 0; i < ret.answers.length; i++) {
                            var payload = {
                                questid: ret.answers[i].id,
                                value: ret.answers[i].value,
                            };
                            this.$store.commit("SET_Answer", payload);
                        }
                    }

                    //this.surv = ret;

                    this.processingApi = false;
                    if (this.shouldGoToFinalSurvey(ret) || ret.surveyEnded) {
                        this.goToFinalSurvey(ret);
                        return;
                    }

                    this.getChapter();
                    if (this.$store.state.startNextReq) {
                        this.nextReq(true);
                        this.$store.commit("SET_StarNextReq", false);
                    }

                    this.showBtnOk = false;
                    if (this.currentReq.config)
                        if (this.currentReq.config.includes("btnok")) {
                            this.showBtnOk = true;
                        }
                    this.fimChap = false;
                },
                (err) => {
                    this.processingApi = true;
                    alert(err);
                    location.reload()
                }
            );
        },
        checkCPF(value) {
            if (!value) return false;
            let Soma;
            let Resto;
            Soma = 0;
            value = value.replace(/[^\d]/g, "");
            if (value == "00000000000") return false;
            if (value == "11111111111") return false;
            if (value == "22222222222") return false;
            if (value == "33333333333") return false;
            if (value == "44444444444") return false;
            if (value == "55555555555") return false;
            if (value == "66666666666") return false;
            if (value == "77777777777") return false;
            if (value == "88888888888") return false;
            if (value == "99999999999") return false;
            let i;
            for (i = 1; i <= 9; i++)
                Soma = Soma + parseInt(value.substring(i - 1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;

            if (Resto == 10 || Resto == 11) Resto = 0;
            if (Resto != parseInt(value.substring(9, 10))) return false;

            Soma = 0;
            for (i = 1; i <= 10; i++)
                Soma = Soma + parseInt(value.substring(i - 1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;

            if (Resto == 10 || Resto == 11) Resto = 0;
            if (Resto != parseInt(value.substring(10, 11))) return false;
            return true;
        },
    },
    created() {
        this.btnLabel = this.$t('advance');
        this.getChapter();
        if (this.$store.state.startNextReq) {
            this.nextReq(false);
            this.$store.commit("SET_StarNextReq", false);
        }

        this.showBtnOk = false;
        if (this.currentReq.config)
            if (this.currentReq.config.includes("btnok")) {
                const configArray = this.currentReq.config.split(";");
                const label = configArray
                    .filter((e) => e.startsWith("btnok"))[0]
                    .split(":")[1];
                this.btnLabel = label;
                this.showBtnOk = true;
            }
    },
};
</script>

<style>
@media (min-width: 700px) {
    .padding-desk {
        margin-top: 0px;
    }
}

.padding-desk {
    margin-top: 35px;
}
</style>
